["README.md","be","de","el","en-CA","en-GB","en-US","es-CL","fr","fur","fy-NL","ia","it","kab","nl","pt-BR","ro","ru","sr","sv-SE","tr","uk","zh-CN","zh-TW"]